<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="row">
    <div class="col-3" style="text-align: left; margin: 5px;">
      <button type="button" class="btn btn-secondary btn-block" (click)="goFuentes()" style="overflow: hidden; white-space: normal; max-width: 100%;">Administración Fuentes</button>
    </div>
  </div>
  <div class="row">
    <div class="col-3" style="text-align: left; margin: 5px;">
      <div class="btn-group dropright btn-block">
        <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false" style="overflow: hidden; white-space: normal; max-width: 100%;">
          Administración Variables Reporte
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" (click)="goVariableschv()">Cartera Hipotecaria de Vivienda</a></li>
          <li><a class="dropdown-item" (click)="goVariablesfivi()">Financiación de Vivienda</a></li>
        </ul>
      </div>
    </div>
  </div>
</body>


